import Skeleton from '@ancon/wildcat-ui/web/orderweb/Skeleton'
import '@ancon/wildcat-ui/web/orderweb/Skeleton/Skeleton.css'

export default Skeleton
